module.exports = __webpack_public_path__ + "static/creator-tokens-share-upside-9682330f77edef947e4fbe3621f1f025.webp";